import { EXPORT_STATUS } from 'dynamo-daos/build/models/exports/exportRecord';

import apiRequest from './apiRequest';

type ApiResponse = {
  animationNumber: number;
  characterID: string;
  createdAt: string;
  estimatedFinishTime: string;
  jobID: string;
  mostRecentDownloadPath: string;
  retriesRemaining: number;
  status: EXPORT_STATUS;
  userID: string;
};

export default async function getExportJob(
  jobID: string,
  animationNumber: string,
  characterID: string,
) {
  return await apiRequest<ApiResponse>(
    'mogen-orchestration',
    `/jobs/${jobID}/export?animationNumber=${animationNumber}&characterID=${characterID}`,
  );
}
